export default __webpack_public_path__ + "static/media/password-protected-group.d47aaeec.svg";